import React, { useEffect } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { useState } from "react";
import { connect } from "react-redux";
import "../View/Card_view/cardView.css";

const containerStyle = {
  width: "100%",
  height: "100%",
};
// window.innerWidth >= 1025 ? "420px" : "396px"
const MapComponentDetail = ({
  detailData,
  propertyLoading,
  like,
  unlike,
  hidden,
  label,
}) => {
  const { frontLabelsName } = label;
  const [viewProp, setViewProp] = useState();

  const [displayData, setDisplayData] = useState();

  // console.log(detailData);

  useEffect(() => {
    setDisplayData(detailData);
  }, [detailData]);

  const getPropertyType = (val) => {
    if (val?.length > 0) {
      let label;
      if (val?.includes("1") && val?.includes("2") && val?.includes("3")) {
        label = "Rental, Sale, PG";
      } else if (val?.includes("1") && val?.includes("2")) {
        label = "Rental, Sale";
      } else if (val?.includes("2") && val?.includes("3")) {
        label = "Sale, PG";
      } else if (val?.includes("3") && val?.includes("1")) {
        label = "Rental, PG";
      } else if (val?.includes("1")) {
        label = "Rental";
      } else if (val?.includes("2")) {
        label = "Sale";
      } else {
        label = "PG";
      }
      return label;
    }
  };

  const getTypeName = (val) => {
    if (val === "detachedHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
          "value"
          ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house";
    } else if (val === "duplex") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
          "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex";
    } else if (val === "tripleAptHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
          "value"
          ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house";
    } else if (val === "aptBulding") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0]["value"] ||
          "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building";
    } else if (val === "townhouseTwin") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
          "value"
          ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin";
    } else if (val === "garage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
          "lbl_garage"
          : "lbl_garage"
        : "lbl_garage";
    } else if (val === "summerHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0]["value"] ||
          "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house";
    } else if (val === "cotenant") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0]["value"] ||
          "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant";
    } else if (val === "hotelGesthouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
          "value"
          ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house";
    }
  };

  const mapRef = React.useRef(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCb1YPbyCqwlT6XLU83s9UqZViwzEtXRzc",
  });

  const onLoad = React.useCallback(
    (mapInstance) => {
      const bounds = new window.google.maps.LatLngBounds();
      !propertyLoading &&
        bounds.extend(
          new window.google.maps.LatLng(
            parseFloat(displayData?.lat),
            parseFloat(displayData?.lng)
          )
        );

      mapRef.current = mapInstance;
      mapInstance.fitBounds(bounds);
    },
    [displayData]
  );

  const onHoverMarker = (id) => {
    // setViewProp(property?.docs.find((val) => val._id === id));
  };

  const handleLike = () => {
    // like(viewProp?._id);
    // onHoverMarker(null);
  };

  const handleUnlike = () => {
    // unlike(viewProp?._id);
    // onHoverMarker(null);
  };

  const handleHide = () => {
    // hidden(viewProp?._id);
    // onHoverMarker(null);
  };

  return (
    <>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          onLoad={onLoad}
          zoom={13}
          onRightClick={() => onHoverMarker(null)}
        >
          {!propertyLoading && (
            <Marker
              key={displayData?._id}
              onMouseOver={() => onHoverMarker(displayData?._id)}
              position={{
                lat: parseFloat(displayData?.lat),
                lng: parseFloat(displayData?.lng),
              }}
              icon={ "http://dev.saturncube.com/property/uploads/newMarker.png"}
            />
          )}

          {viewProp && (
            <InfoWindow
              position={{
                lat: parseFloat(viewProp.lat),
                lng: parseFloat(viewProp.lng),
              }}
              onCloseClick={() => setViewProp(null)}
            >
              <div className="col-lg-12 col-md-12">
                <div className="view-card-main mt-4">
                  <div className="icon-main-view">
                    {viewProp?.favourite === 0 ? (
                      <img
                        src="assets/icons/Favourite.svg"
                        alt="hshshs"
                        onClick={handleLike}
                        style={{
                          cursor: "pointer",
                          width: "32px",
                          height: "32px",
                        }}
                      />
                    ) : (
                      <img
                        src="assets/like.svg"
                        alt="hshshs"
                        onClick={handleUnlike}
                        style={{
                          cursor: "pointer",
                          width: "32px",
                          height: "32px",
                        }}
                      />
                    )}

                    <img
                      src="assets/hidden.svg"
                      alt="hshshs"
                      style={{
                        cursor: "pointer",
                        width: "32px",
                        height: "32px",
                      }}
                      onClick={handleHide}
                    />
                  </div>
                  <div
                    // className={`${
                    //   allData ? "img-view-main3" : "img-view-main"
                    // }`}
                    className="img-view-main3"
                  >
                    <img src={viewProp.cover_photo} alt="cover_photo" />
                  </div>
                  <div className="overlayblack-card">
                    <div className="set-overlay">
                      <p>{`${
                        viewProp.location.length > 45
                          ? viewProp.location.substring(0, 45) + " ..."
                          : viewProp.location
                      }, ${viewProp.area}`}</p>
                      <div className="bottom-desc d-flex">
                        <p>
                          {`${getTypeName(viewProp?.propertyType)}, ${
                            viewProp.bhk === "Storage"
                              ? frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_storage"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_storage"
                                    )[0]["value"] || "lbl_storage"
                                  : "lbl_storage"
                                : "lbl_storage"
                              : viewProp.bhk === "Single Room"
                              ? frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_single_room"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_single_room"
                                    )[0]["value"] || "lbl_single_room"
                                  : "lbl_single_room"
                                : "lbl_single_room"
                              : viewProp.bhk === "Studio"
                              ? frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_studio"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_studio"
                                    )[0]["value"] || "lbl_studio"
                                  : "lbl_studio"
                                : "lbl_studio"
                              : `${viewProp?.bhk} ${
                                  frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_rooms"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_rooms"
                                        )[0]["value"] || "lbl_rooms"
                                      : "lbl_rooms"
                                    : "lbl_rooms"
                                }`
                          } ` ||
                            `${getPropertyType(viewProp.property_type)}, ${
                              viewProp.bhk
                            } rooms`}
                        </p>
                        <p>
                          {viewProp.propertyPrice ||
                            viewProp.property_price ||
                            viewProp.sale_price ||
                            viewProp.pg_price}{" "}
                          kr.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  label: state.language,
});
export default connect(mapStateToProps, {})(MapComponentDetail);
